import { Component } from 'react'
import { PERMISSIONS } from '../constants'
import { containsAll } from '../helpers/contains'

class PermissionsManager extends Component {
  constructor(props) {
    super(props)
    this.props = props
    this.permissions = localStorage.getItem(PERMISSIONS).split(',')
  }

  render() {
    if (containsAll(this.props.hasPermissions, this.permissions) === true) {
      return this.props.children
    } else {
      return null
    }
  }
}

export default PermissionsManager



// WEBPACK FOOTER //
// ./src/components/PermissionsManager.js